// extracted by mini-css-extract-plugin
export var readonly = "_fs-1";
export var star = "_fs-0";